import { Column, Id, Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { eventFeedbackEvaluationService } from "../../api/eventFeedbackEvaluationService";
import { FeedbackEvaluation } from "../../feedback/FeedbackEvaluation";

interface Props {
	eventId: Id;
}
export const EventFeedbackEvaluation: FC<Props> = ({ eventId }) => {
	const { data: feedbackEvaluations, isLoading } = useQuery({
		queryKey: eventFeedbackEvaluationService.eventFeedbackEvaluationsKey(eventId),
		queryFn: () => eventFeedbackEvaluationService.getEventFeedbackEvaluation(eventId).then((res) => res.data.data),
	});

	if (!feedbackEvaluations || isLoading) return <Loading />;

	return (
		<Column $rowGap={6}>
			{feedbackEvaluations.map((evaluation) => (
				<FeedbackEvaluation key={evaluation.feedback.id} eventId={eventId} feedback={evaluation} />
			))}
		</Column>
	);
};
